import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FaMapLocationDot, FaPhone } from "react-icons/fa6";
import { IoIosMail } from "react-icons/io";
import { IoTime } from "react-icons/io5";

const BranchesContainer = styled.div`
  min-height: 100vh;
  background-color: #f8f9fa;
`;

const HeroSection = styled.section`
  background: linear-gradient(135deg, #ff6720 0%, #ff8c42 100%);
  color: white;
  padding: 80px 0;
  text-align: center;
`;

const HeroTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.2rem;
  max-width: 600px;
  margin: 0 auto;
  opacity: 0.9;
`;

const BranchesSection = styled.section`
  padding: 80px 0;

  @media (max-width: 480px) {
    padding: 40px 0;
  }
`;

const BranchFilters = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 50px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileFilterContainer = styled.div`
  display: none;
  margin-bottom: 30px;
  text-align: center;

  @media (max-width: 768px) {
    display: inline-block;
    justify-content: start;
    align-items: start;
  }
`;

const MobileFilterTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
`;

const MobileBranchFilter = styled.select`
  padding: 8px 22px;
  border: 2px solid #333;
  border-radius: 25px;
  background-color: white;
  color: #333;
  font-weight: 600;
  font-size: 1rem;
  appearance: none;
  background-image: url('data:image/svg+xml;utf8,<svg fill="%23333" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>');
  background-repeat: no-repeat;
  background-position: right 10px center;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #333333af;
  }
`;

const FilterButton = styled.button`
  padding: 12px 24px;
  border: 2px solid #ff6720;
  border-radius: 25px;
  background-color: ${(props) => (props.active ? "#ff6720" : "transparent")};
  color: ${(props) => (props.active ? "white" : "#ff6720")};
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    background-color: #ff6720;
    color: white;
  }
`;

const BranchGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    padding: 0px;
    gap: 20px;
  }
`;

const BranchCard = styled.div`
  background: white;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  }
`;

const BranchImage = styled.div`
  height: 200px;
  background: ${props => props.$bgImage 
    ? `url(${props.$bgImage}) center/cover no-repeat` 
    : 'linear-gradient(135deg, #ff6720, #ff8c42)'};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: ${props => props.$bgImage ? '""' : '"🏢"'};
    font-size: 4rem;
  }
`;

const BranchContent = styled.div`
  padding: 25px;
`;

const BranchName = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
`;

const BranchType = styled.span`
  background-color: #ff6720;
  color: white;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 15px;
  display: inline-block;
`;

const BranchInfo = styled.div`
  margin-bottom: 20px;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  font-size: 0.95rem;
  color: #666;
`;

const InfoIcon = styled.span`
  margin-right: 12px;
  font-size: 1.1rem;
  width: 20px;
`;

const BranchActions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

const ActionButton = styled.button`
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  flex: 1;
  min-width: 120px;

  &.primary {
    background-color: #ff6720;
    color: white;

    &:hover {
      background-color: #e55a1c;
    }
  }

  &.secondary {
    background-color: transparent;
    color: #ff6720;
    border: 1px solid #ff6720;

    &:hover {
      background-color: #ff6720;
      color: white;
    }
  }
`;

const BnIcon = styled.div`
  font-size: 20px;
  display: flex;
  margin-right: 10px;
  color: #1b1b1bff;
  align-items: center;
  justify-content: center;
`;

const branches = [
  {
    id: 1,
    name: "STIHL XPLOD TOOLS",
    type: "Head Office",
    category: "pathanamthitta",
    address: "SH8, Kumbazha, Mylapra, Pathanamthitta, Kerala",
    mapUrl: "https://maps.app.goo.gl/d7fku4BCmeMAFwb5A",
    phone: "+91 9446189273",
    email: "info@blackanddecker.com",
    image: "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noDFV9bFGfGYbrxI0AEbvyXsGd-PEYSSd1Mp2hDfj0tuFcFG6mHbbKDox7YS2I3I0r0ohfTApuqLLVEjAmR4UO5aU9aru6pbUuQipsOuvCN5ARqzZEyDSw1uvdNcM1f2eGsX_14SA=w408-h725-k-no",
    hours: "Mon-Sat: 8:30 AM - 7:30 PM",
    services: [
      "Corporate Operations",
      "Customer Service",
      "Product Development",
    ],
  },
  {
    id: 2,
    name: "STIHL AGRI TECH",
    type: "Branch",
    category: "trivandrum",
    address: "PVMX+W6Q, Kazhakoottam - Kilimanoor Rd, Karette, Kerala",
    lat: 8.734849322127499,
    lng: 76.89801195204323,
    phone: "+1 (212) 555-0123",
    email: "ny.service@blackanddecker.com",
    image: "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nr5zA5qbgaN3g1-ed7hauqw89Xae9Cf6czktgSUeEsVFYksYzI71FkITsY9AYkZ3fQ_URbEO9GOky0xW89rWg9SL865zDT8ZesSTM-sG2_brTcKqMJvhGd2h-EBYgA2jWHFIlxeyA=w408-h306-k-no",
    hours: "Mon-Sat: 8:30 AM - 7:00 PM",
    services: ["Product Repairs", "Warranty Claims", "Parts & Accessories"],
  },
  {
    id: 3,
    name: "STIHL XPLOD AGROS",
    type: "Branch",
    category: "kottayam",
    address: "Thengana-Thiruvanchoor Rd, Manarcadu, Kerala",
    lat: 9.589774023174282, 
    lng: 76.5827373312311,
    phone: "+91 9747452539",
    email: "la.distribution@blackanddecker.com",
    image: "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nosPQRjFX7ZoDYa1_SXOujBD4pVLzoSEeY1BsYLrIGnsXA2dd7GpPSmWNNWd66sbIPzPtuXGqkhM6AxWPm1ciDmwQpfaMTSpz-yQyWJV5AU0dinFsiL2y5jG3Ie9rEi9-jHUUFi=w408-h544-k-no",
    hours: "Mon-Sat: 8:30 AM - 7:00 PM",
    services: [
      "Product Distribution",
      "Wholesale Orders",
      "Inventory Management",
    ],
  },
  {
    id: 4,
    name: "STIHL MOTO AGRO",
    type: "Branch",
    category: "pathanamthitta",
    address: "5P4R+PGC, Adoor, Kerala",
    mapUrl: "https://maps.app.goo.gl/aTNMkWEHE14K7F8A6",
    phone: "+1 (312) 555-0177",
    email: "chicago@blackanddecker.com",
    image: "https://www.google.com/maps/place/Stihl+Moto+Agro+Power+Tools/@9.1565609,76.7413503,3a,75y,90t/data=!3m8!1e2!3m6!1sCIHM0ogKEICAgIDxmseexwE!2e10!3e12!6shttps:%2F%2Flh3.googleusercontent.com%2Fgps-cs-s%2FAC9h4nrmTloFWBiuWk7wB_IO3XQssJlgaJcRsh1TzgUlwXrM-tgeZlIZkmDtPDfrkYQnqnaTuuMePGeGvgH-j--gXBgl60Bu8bK15D9keGj5AKptis2KEQprO_9rLzKLkNK47uuiTgzJ2g%3Dw114-h86-k-no!7i4032!8i3024!4m7!3m6!1s0x3b06134b7782e307:0x8960b31c0124411a!8m2!3d9.1566013!4d76.7412125!10e5!16s%2Fg%2F11kq14045h?authuser=0&entry=ttu&g_ep=EgoyMDI1MDkyOS4wIKXMDSoASAFQAw%3D%3D#",
    hours: "Mon-Sat: 8:30 AM - 6:30 PM",
    services: ["Sales Support", "Training Programs", "Technical Support"],
  },
  {
    id: 5,
    name: "STIHL MACHINE WORLD",
    type: "Branch",
    category: "kollam",
    address: "VILAKKUDY PANCHAYAT, Kunnicode, Kerala 691508",
    mapUrl: "https://maps.app.goo.gl/W25gYtC3pg7gxYYg6",
    phone: "+91 8848064407",
    email: "atlanta.service@blackanddecker.com",
    image: "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noYK7seY5aEksiyVoQRZGXcKB6r4P3xNA3Oed89rlBSnaZplqo5CDsiOIY5Daz4w6J8ThchYGeqWXsPCoDvuMYQOygIyedN6atfSk07-2s55o0vPyhsS2DIIcfGC-EZe6itsmbU=w408-h306-k-no",
    hours: "Mon-Sat: 8:30 AM - 6:30 PM",
    services: ["Product Repairs", "Warranty Service", "Technical Consultation"],
  },
  {
    id: 6,
    name: "STIHL AGRITECH ARYANAD",
    type: "Branch",
    category: "trivandrum",
    address: "Parthasaradhi, Agritech, Building Tholoor, PO, Cherukulam, Aryanad, Kerala",
    lat: 8.5816154484634, 
    lng: 77.08112080971321,
    phone: "+91 9747459993",
    email: "dallas@blackanddecker.com",
    hours: "Mon-Sat: 8:30 AM - 7:00 PM",
    services: ["Regional Sales", "Customer Support", "Training Center"],
  },
];

const categories = [
  { key: "all", label: "All Locations" },
  { key: "trivandrum", label: "Trivandrum" },
  { key: "kollam", label: "Kollam" },
  { key: "pathanamthitta", label: "Pathanamthitta" },
  { key: "alappuzha", label: "Alappuzha" },
  { key: "kottayam", label: "Kottayam" },
];

function BranchesPage() {
  const [activeFilter, setActiveFilter] = useState("all");

  useEffect(() => {
    document.title = "Our Branches | XPLOD-GROUPS";
    return () => {
      document.title = "Home | XPLOD-GROUPS";
    };
  }, []);

  const filteredBranches =
    activeFilter === "all"
      ? branches
      : branches.filter((branch) => branch.category === activeFilter);

  const handleGetDirections = (mapUrl) => {
    window.open(mapUrl, "_blank");
  };

  const handleContact = (phone) => {
    window.open(`tel:${phone}`, "_self");
  };

  return (
    <BranchesContainer>
      <HeroSection>
        <div className="container">
          <HeroTitle>Our Locations</HeroTitle>
          <HeroSubtitle>
            Find a STIHL XPLOD-GROUPS location near you for product support, services,
            and expert assistance with all your machine needs.
          </HeroSubtitle>
        </div>
      </HeroSection>

      <BranchesSection>
        <div className="container">

          <BranchFilters>
            {categories.map((category) => (
              <FilterButton
                key={category.key}
                active={activeFilter === category.key}
                onClick={() => setActiveFilter(category.key)}
              >
                {category.label}
              </FilterButton>
            ))}
          </BranchFilters>
          <MobileFilterContainer>
            <MobileFilterTitle>Find nearest Branch</MobileFilterTitle>
            <MobileBranchFilter
              value={activeFilter}
              onChange={(e) => setActiveFilter(e.target.value)}
            >
              {categories.map((category) => (
                <option key={category.key} value={category.key}>
                  {category.label}
                </option>
              ))}
            </MobileBranchFilter>
          </MobileFilterContainer>

          <BranchGrid>
            {filteredBranches.map((branch) => (
              <BranchCard key={branch.id}>
                <BranchImage $bgImage={branch.image} />
                <BranchContent>
                  <BranchName>{branch.name}</BranchName>
                  <BranchType>{branch.type}</BranchType>

                  <BranchInfo>
                    <InfoItem>
                      <BnIcon>
                       <FaMapLocationDot />
                      </BnIcon>
                      <span>{branch.address}</span>
                    </InfoItem>
                    <InfoItem>
                      <BnIcon>
                       <FaPhone />
                      </BnIcon>
                      <span>{branch.phone}</span>
                    </InfoItem>
                    <InfoItem>
                      <BnIcon>
                       <IoIosMail />
                      </BnIcon>
                      <span>{branch.email}</span>
                    </InfoItem>
                    <InfoItem>
                      <BnIcon>
                       <IoTime />
                      </BnIcon>
                      <span>{branch.hours}</span>
                    </InfoItem>
                  </BranchInfo>

                  {/* <div style={{ marginBottom: "20px" }}>
                    <strong>Services:</strong>
                    <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
                      {branch.services.map((service, index) => (
                        <li
                          key={index}
                          style={{ marginBottom: "4px", color: "#666" }}
                        >
                          {service}
                        </li>
                      ))}
                    </ul>
                  </div> */}

                  <BranchActions>
                    <ActionButton
                      className="primary"
                      onClick={() => handleGetDirections(branch.mapUrl)}
                    >
                      Get Directions
                    </ActionButton>
                    <ActionButton
                      className="secondary"
                      onClick={() => handleContact(branch.phone)}
                    >
                      Call Now
                    </ActionButton>
                  </BranchActions>
                </BranchContent>
              </BranchCard>
            ))}
          </BranchGrid>
        </div>
      </BranchesSection>
    </BranchesContainer>
  );
}

export default BranchesPage;
